module.exports = __webpack_public_path__ + "5c114213/img/pwrd-by-sourcery-black.bba9ba41.svg";